// extracted by mini-css-extract-plugin
export var popup_wrapper = "popup-cta-module--popup_wrapper--2dur_";
export var active = "popup-cta-module--active--1B_Vi";
export var shadow = "popup-cta-module--shadow--2bGxV";
export var content = "popup-cta-module--content--kqvqP";
export var close_btn = "popup-cta-module--close_btn--2Fmnt";
export var before_form = "popup-cta-module--before_form--2-_4o";
export var subtitle = "popup-cta-module--subtitle--3c_zt";
export var separator = "popup-cta-module--separator--9hlxq";
export var before_title = "popup-cta-module--before_title--1P0mf";